import { IconName } from '@usealloy/component-library';

export const ENTITY_TYPES = {
  PERSON: 'person',
  BUSINESS: 'business',
  GROUP: 'group',
  ENTITY_GROUP: 'entity-group',
} as const;

export type EntityType = (typeof ENTITY_TYPES)[keyof typeof ENTITY_TYPES];

// Normalize entity type from backend format (entity_group) to frontend format (entity-group)
export const normalizeEntityType = (type: string | undefined): EntityType | undefined => {
  if (!type) return undefined;
  if (type === 'entity_group') return ENTITY_TYPES.ENTITY_GROUP;
  const validTypes = Object.values(ENTITY_TYPES) as string[];
  return validTypes.includes(type) ? (type as EntityType) : undefined;
};

export const ENTITY_ICON_MAP: Record<EntityType, IconName> = {
  [ENTITY_TYPES.PERSON]: IconName.Person,
  [ENTITY_TYPES.BUSINESS]: IconName.Business,
  [ENTITY_TYPES.GROUP]: IconName.Group,
  [ENTITY_TYPES.ENTITY_GROUP]: IconName.CustomGroup,
};

